export const disableAutoRefillRequestDefault = '{\n' +
    '    "drugId": "",\n' +
    '    "personId": "",\n' +
    '    "profileId": "",\n' +
    '    "prescriptionId": ""\n' +
    '}';

export interface IDisableAutoRefillRequest {
    drugId: string,
    personId: string,
    profileId: string,
    prescriptionId: string
}